import React, { useEffect, useState } from "react";
import { Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductFeaturesHandler } from "../../redux/action/getproductFeaturesSlice";
import Loader from "../../components/Loder/loader";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { BreadCrum } from "../../common";
import { getItem, removeItem } from "../../common/localStorage";
import { getProductFeatureNavigateUrl } from "./productNavigation";

const ViewProduct = () => {
  const getAllFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures,
  );
  const [switchInfos, setSwitchInfos] = useState({});
  const [activeStatus, setActiveStatus] = useState(false);
  const [productData, setShowProductData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const product_id = getItem("productId");

  useEffect(() => {
    if (state?.productId || product_id) {
      dispatch(
        getProductFeaturesHandler({
          productId: state?.productId || product_id,
        }),
      );
      setShowProductData(state);
    }
  }, [state, product_id, dispatch]);

  useEffect(() => {
    const newSwitchInfos = {};
    getAllFeaturesSelector?.data?.data?.productFeature?.forEach((element) => {
      newSwitchInfos[element.id] = element.status === "ACTIVE";
    });
    setSwitchInfos(newSwitchInfos);
  }, [getAllFeaturesSelector]);

  useEffect(() => {
    setActiveStatus(
      getAllFeaturesSelector?.data?.data?.activeStatus === "ACTIVE",
    );
  }, [getAllFeaturesSelector]);

  const productDetails = getAllFeaturesSelector?.data?.data;

  return (
    <>
      {getAllFeaturesSelector?.isLoading === true && (
        <Loader loaderTansform="loaderTansform" />
      )}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Products</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              {
                text: BreadCrum.PRODUCTS,
                onClick: () => {
                  navigate("/product");
                  removeItem("productId");
                },
              },
              { text: BreadCrum.MANAGE_PRODUCTS, active: true },
            ]}
          />
          <div className="login-form mx750">
            <div className="product-view-info mb-30">
              <div className="product-view-info-field">
                <p className="product-view-info-label">Product Name</p>
                <p className="product-view-info-value">
                  {productDetails?.name || state?.productName || "-"}
                </p>
              </div>
              <div className="product-view-info-divider" aria-hidden="true" />
              <div className="product-view-info-field">
                <p className="product-view-info-label">Product Code</p>
                <p className="product-view-info-value">
                  {productDetails?.code || state?.productCode || "-"}
                </p>
              </div>
              <div className="product-view-info-divider" aria-hidden="true" />
              <div className="product-view-info-status">
                <div className="mx-50 text-center">
                  <div className="productname mb-10 text-nowrap">
                    Product Status
                  </div>
                  <Switch
                    className="switches"
                    checked={activeStatus}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="grid2 mb-30">
              {productDetails?.activeStatus === "ACTIVE" &&
                productDetails?.productFeature?.map((item) => (
                  <div className="optionrow" key={item.id}>
                    <div className="option">
                      <div className="optionflex">
                        <div className="optiontext">{item?.featureName}</div>
                        <div className="d-flex align-items-center">
                          <Switch
                            checked={switchInfos[item.id]}
                            className="me-3 switches"
                            disabled
                          />
                          <button
                            type="button"
                            className="manage"
                            onClick={() =>
                              getProductFeatureNavigateUrl(
                                navigate,
                                item,
                                productData,
                                { viewProduct: true },
                              )
                            }
                            disabled={!switchInfos[item.id]}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="text-end">
            <button
              type="button"
              onClick={() => {
                navigate("/product");
                removeItem("productId");
              }}
              className="border-0 py3 fw-18 gbo ms-auto bgtransparent addcreatebtn"
            >
              <span>Go back to listing</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewProduct;
